import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { FullScreenLoader } from "./FullScreenLoader";

export const AuthCallback = () => {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/", { replace: true });
      })
      .catch(() => {
        setUser(false);
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return <FullScreenLoader />;
};
